import { Button } from '@nexelem/components';
import { openSaveViewModal } from './SaveViewModal';
import { useTableTranslation } from '../../translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/pro-light-svg-icons';
import { type TableState, useTableName } from '../../utils';
import { useIsDirtyView } from '../../filters/useIsDirtyView';
import { Decoder } from '../../filters/Decoder';
import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';

export const SaveViewButton = () => {
  const { t } = useTableTranslation();
  const tableName = useTableName();
  const isDirtyView = useIsDirtyView();
  const { getValues } = useFormContext<TableState>();

  const handleSaveView = useCallback(async () => {
    // Always encode current form — URL `f` may still be stale during debounce.
    const data = await Decoder.encode(getValues());
    openSaveViewModal({ tableName, data });
  }, [getValues, tableName]);

  return (
    <Button
      className="ml-auto"
      disabled={!isDirtyView}
      StartIcon={<FontAwesomeIcon icon={faBookmark} />}
      variant="text"
      onClick={() => void handleSaveView()}
    >
      {t('saveView')}
    </Button>
  );
};
